/**
 * Léxico por universo.
 *
 * Un estado vacío no es "sin datos": es una frase que el usuario lee, y
 * tiene que sonar al mundo del tema activo. "El péndulo está quieto" es
 * correcto en Niebla Gris y es un bug en Netrunner.
 *
 * Mismo patrón que THEME_PHRASES en routes/chat.tsx, pero agrupado por
 * universo en vez de por tema: los siete temas cyberpunk comparten
 * vocabulario, no hace falta repetirlo siete veces.
 */

import type { Universe } from "./index";

/** Situaciones semánticas, nunca nombres de dibujo. El slot dice QUÉ pasa;
 *  el universo decide cómo se ve y cómo se llama. */
export type EmptySlot = "no-items" | "no-schedule" | "no-sessions" | "no-signal";

export interface EmptyCopy {
  title: string;
  hint: string;
}

const LEXICON: Record<Universe, Record<EmptySlot, EmptyCopy>> = {
  cyberpunk: {
    "no-items": {
      title: "Inventario vacío",
      hint: "Este nodo no tiene nada almacenado todavía.",
    },
    "no-schedule": {
      title: "Cola vacía",
      hint: "Ningún proceso encolado para este ciclo.",
    },
    "no-sessions": {
      title: "Sin conexiones activas",
      hint: "Ningún enlace abierto contra el daemon.",
    },
    "no-signal": {
      title: "Señal perdida",
      hint: "El enlace cayó. Reintentando el handshake.",
    },
  },
  arcane: {
    "no-items": {
      title: "Sin cartas reveladas",
      hint: "El mazo sigue sellado.",
    },
    "no-schedule": {
      title: "El péndulo está quieto",
      hint: "No hay rituales en curso.",
    },
    "no-sessions": {
      title: "Ninguna puerta abierta",
      hint: "Nadie ha cruzado la niebla todavía.",
    },
    "no-signal": {
      title: "La vela se apagó",
      hint: "El enlace se cortó. Encendiendo de nuevo.",
    },
  },
};

export function emptyCopy(universe: Universe, slot: EmptySlot): EmptyCopy {
  return LEXICON[universe][slot];
}
